export default __webpack_public_path__ + "static/media/inventory-icon.d7b32575.svg";